/* ContactBar retired — the Buitn Planten header now includes its own announcement strip. This component renders nothing so existing call sites don't need updating. */
export default function ContactBar() {
  return null;
}
